export default __webpack_public_path__ + "static/media/medical_device_programming_language.6a1eb1a3.jpg";